import type {ExpandState, ProjectId} from '../types'
import type {KeyValue} from '../utils/object'

import {useSlice} from './useSlice'

type State = Readonly<{
  searchQuery: string
  expandState: KeyValue<ProjectId, ExpandState>
}>
type ExpandParams = {
  projectId: ProjectId
  expanded: boolean
}
type Handlers = {
  setSearchQuery: (arg0: string) => unknown
  toggleExpandState: (arg0: ExpandParams) => unknown
}

const useProjectsSearch = (
  initialState: State = {
    searchQuery: '',
    expandState: {},
  },
): [State, Handlers] =>
  useSlice(
    {
      setSearchQuery: (state, query) => ({
        searchQuery: query,
        expandState: {},
      }),
      toggleExpandState: (state: State, {projectId, expanded}) => ({
        ...state,
        expandState: {
          ...state.expandState,
          [projectId]: {
            type: 'project',
            id: projectId,
            expandState: expanded ? 'EXPANDED' : 'COLLAPSED',
          },
        },
      }),
    },
    initialState,
  )

export default useProjectsSearch
